/**
 * Carnet d'adresses — le schéma `core` de la Supabase (clients, adresses,
 * contacts du CRM), lu par l'API en LECTURE SEULE (migration 0081).
 *
 * L'outil n'en recopie rien : il le consulte au moment de la saisie. Le client
 * se désigne par son `numeroClient` (clé métier du CRM, ex N° Agiris), jamais
 * par l'id technique d'une base qui n'est pas la sienne.
 */
/**
 * Une adresse `core` en une ligne : « 12 rue de Paris, 53000 Laval ».
 *
 * Le pays n'est écrit que hors de France : c'est la forme que la BAN géocode
 * le mieux, et celle qu'un collaborateur aurait tapée. Rend null quand il n'y a
 * rien d'exploitable (une adresse vide ne doit pas écraser une saisie).
 */
export function formaterAdresse(a) {
    if (!a)
        return null;
    const propre = (v) => (v ?? '').replace(/\s+/g, ' ').trim();
    const rue = propre(a.rue);
    const localite = [propre(a.codePostal), propre(a.ville)].filter(Boolean).join(' ');
    const pays = propre(a.pays);
    const etranger = pays !== '' && pays.toLowerCase() !== 'france';
    const morceaux = [rue, localite, etranger ? pays : ''].filter(Boolean);
    return morceaux.length ? morceaux.join(', ') : null;
}
/**
 * Code court proposé pour une société (« IT Solutions » → « ITS »,
 * « Altonéo » → « ALT ») : les initiales des mots significatifs, ou les trois
 * premières lettres d'un nom en un mot. Une PROPOSITION : l'administrateur la
 * corrige s'il le souhaite, elle ne remplace jamais un code déjà saisi.
 */
export function proposerCodeSociete(raisonSociale) {
    const mots = raisonSociale
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/\(.*?\)/g, ' ')
        .split(/[^A-Za-z0-9]+/)
        .filter((m) => m && !['DE', 'DU', 'DES', 'LA', 'LE', 'LES', 'ET', 'SA', 'SAS', 'SARL', 'EURL'].includes(m.toUpperCase()));
    if (mots.length === 0)
        return '';
    if (mots.length === 1)
        return mots[0].slice(0, 3).toUpperCase();
    // Un sigle écrit en capitales (« IT ») se garde entier : « IT Solutions » → « ITS ».
    const sigle = (m) => m.length <= 4 && m === m.toUpperCase() && /[A-Z]/.test(m);
    return mots
        .map((m) => (sigle(m) ? m : m[0].toUpperCase()))
        .join('')
        .slice(0, 5);
}
/** Même nom à la casse, aux accents et aux espaces près : « Altonéo » = « ALTONEO ». */
export function memeNom(a, b) {
    const n = (v) => (v ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
    return n(a) !== '' && n(a) === n(b);
}
//# sourceMappingURL=annuaire.js.map